module.exports = __webpack_public_path__ + "media/images/menu-publishers-active-icon-6d158de5e4308d0ab19b79ff38305bdb.svg";